/* eslint-disable @typescript-eslint/no-explicit-any */
import { IconName } from "@fortawesome/fontawesome-svg-core"
import { DocumentoComercialValidacionDtoProps } from "api/DTOs/DocumentoComercialValidacionDto"
import { GetAllImpuestosDtoProps } from "api/DTOs/GetAllImpuestosDto"
import {
  TIPO_DOCUMENTO_ENUM,
  TipoDocumentoEnumType,
} from "api/Types/TipoDocumentoEnum"
import AlbaranService from "common/services/AlbaranService"
import FacturaService from "common/services/FacturaService"
import PedidoService from "common/services/PedidoService"
import PresupuestoService from "common/services/PresupuestoService"
import { TFunction, i18n } from "i18next"
import { ChangeEvent, Dispatch, SetStateAction } from "react"

interface DocumentTypeService {
  label: string
  service: $TSMigrationFixMe
}

interface DocumentTypeServiceMap {
  [key: number]: DocumentTypeService
}

export const TYPES_IMPUESTOS = {
  IMPUESTOS: 0,
  RETENCIONES: 1,
}

export interface DocumentoValidacion {
  id: string
  fechaEmision: string
  importe: number
  nifLibrador: string
  numero: number | null
  numFirmados: number
  numFirmas: number
  razonSocialLibrador: string
  serie: string
  tipoDocumento: number
  tipoDocumentoComercial: number
  key: boolean
  firmas: $TSMigrationFixMe[]
  filter: $TSMigrationFixMe[]
}

export interface ValidacionSelected {
  id: string
  fechaEmision: string
  importe: string
  nifLibrador: string
  numero: null | string
  numFirmados: number
  numFirmas: number
  razonSocialLibrador: string
  serie: string
  tipoDocumento: number
  tipoDocumentoComercial: number
}

export interface ImpuestosFormValuesProps {
  cuentaContableId: string
  articuloId: string
  impuestoEmpresaId: string | null
  porcentaje?: number
  importe?: number
  subtotal?: number
}

export interface RetencionFormValuesProps {
  cuentaContableId: string
  porcentaje?: number
  importe?: number
  subtotal?: number
}
export interface FormValues {
  lastSignature: boolean | undefined
  cuentaContableId: null | string
  importe: number
  impuestos: Array<ImpuestosFormValuesProps>
  listadoTags: string[]
  retenciones: Array<RetencionFormValuesProps>
  subtotal: number
  comentario: string
  fecha: Date | string
  estadoRevision: number
  empresaCreadoraId: string | null
}

export interface DocumentDetailCardProps {
  validacion: $TSMigrationFixMe
  isVistaDetail?: boolean
}

export interface SubData {
  cuentaContableId: string
  impuestoEmpresaId: string | null
  importe: number | string
  porcentaje: number | string
  subtotal: number | string
}
export interface Data {
  lastSignature: boolean
  cuentaContableId: string
  importe: number
  impuestos: SubData[]
  retenciones: SubData[]
  subtotal: number
  comentario: string
  fecha: string
  estadoRevision: number
}

export interface AprobarDocumentoProps {
  // TODO: añadir interfaz formik
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formik: $TSMigrationFixMe
  tabSelected: number
  setTabSelected: Dispatch<SetStateAction<number>>
  validacionesSelected: Array<DocumentoComercialValidacionDtoProps>
  isValidating: boolean
  handleHide: () => void
  tipoImpuestos: Array<GetAllImpuestosDtoProps> | null | undefined
}

export interface DetailStepsProps {
  etapa: $TSMigrationFixMe
  flexContainer: boolean
  isEtapaRejected: boolean
  isVistaDetail?: boolean
  etapas: $TSMigrationFixMe[]
}

export interface DocumentValidationProps {
  documentsToValidate: $TSMigrationFixMe[]
  handleSelect: (selectedDocument: $TSMigrationFixMe) => void
  dataToValidate: $TSMigrationFixMe
  handleChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
  handleHide: () => void
  isValidating: boolean
}

export interface FlowStatusKey {
  label: string
  value: number
  flowStatus?: string
  icon?: IconName
  iconColor?: string
  backgroundColor?: string
  smallIcon?: IconName
  status?: string | undefined
}

export interface TypeDetail {
  label: string
  id: string
  value: number
  flujoAprobaciones: $TSMigrationFixMe[]
  icon: string
  plural: string
  pendientes: string
}

export interface DocTypeKeys {
  [key: string]: TypeDetail
}

export const LABEL_APROBAR_DOCUMENT = (t: i18n["t"], tabSelected: number) => {
  switch (tabSelected) {
    case TIPO_DOCUMENTO_ENUM.FACTURA:
      return t("documentos.validar.aprobar.invoice")
    case TIPO_DOCUMENTO_ENUM.ALBARAN:
      return t("documentos.validar.aprobar.delivery")
    case TIPO_DOCUMENTO_ENUM.PEDIDO:
      return t("documentos.validar.aprobar.order")
    case TIPO_DOCUMENTO_ENUM.PRESUPUESTO:
      return t("documentos.validar.aprobar.quotation")
    default:
      return t("documentos.validar.aprobar.invoice")
  }
}

export const DOC_TYPES_KEYS = (t: TFunction): DocTypeKeys => {
  return {
    [TIPO_DOCUMENTO_ENUM.FACTURA]: {
      label: `${t("documentos.validar.select.invoceLabel")}`,
      id: "Factura",
      value: TIPO_DOCUMENTO_ENUM.FACTURA,
      flujoAprobaciones: [],
      icon: "file-invoice",
      plural: `${t("documentos.validar.select.invoceLabelPlural")}`,
      pendientes: t("documentos.checkLabelMobile.verifyFactura"),
    },
    [TIPO_DOCUMENTO_ENUM.ALBARAN]: {
      label: `${t("documentos.validar.select.deliveryLabel")}`,
      value: TIPO_DOCUMENTO_ENUM.ALBARAN,
      id: "Albarán",
      flujoAprobaciones: [],
      icon: "file-contract",
      plural: `${t("documentos.validar.select.deliveryLabelPlural")}`,
      pendientes: t("documentos.checkLabelMobile.verifyAlbaran"),
    },
    [TIPO_DOCUMENTO_ENUM.PEDIDO]: {
      label: `${t("documentos.validar.select.orderLabel")}`,
      value: TIPO_DOCUMENTO_ENUM.PEDIDO,
      id: "Pedido",
      flujoAprobaciones: [],
      icon: "file-lines",
      plural: `${t("documentos.validar.select.orderLabelPlural")}`,
      pendientes: t("documentos.checkLabelMobile.verifyPedido"),
    },
    [TIPO_DOCUMENTO_ENUM.PRESUPUESTO]: {
      label: `${t("documentos.validar.select.quotationLabel")}`,
      value: TIPO_DOCUMENTO_ENUM.PRESUPUESTO,
      id: "Presupuesto",
      flujoAprobaciones: [],
      icon: "file",
      plural: `${t("documentos.validar.select.quotationLabelPlural")}`,
      pendientes: t("documentos.checkLabelMobile.verifyPresupuesto"),
    },
  }
}

export const ESTADO_APROBACION_DOCUMENTOS = (
  t: TFunction
): Partial<
  Record<
    TipoDocumentoEnumType,
    { text: string; pluralText: string; value: TipoDocumentoEnumType }
  >
> => ({
  [TIPO_DOCUMENTO_ENUM.FACTURA]: {
    text: t("documentos.validar.select.invoceLabel"),
    pluralText: t("documentos.validar.select.invoceLabelPlural"),
    value: TIPO_DOCUMENTO_ENUM.FACTURA,
  },
  [TIPO_DOCUMENTO_ENUM.ALBARAN]: {
    text: t("documentos.validar.select.deliveryLabel"),
    pluralText: t("documentos.validar.select.deliveryLabelPlural"),
    value: TIPO_DOCUMENTO_ENUM.ALBARAN,
  },
  [TIPO_DOCUMENTO_ENUM.PEDIDO]: {
    text: t("documentos.validar.select.orderLabel"),
    pluralText: t("documentos.validar.select.orderLabelPlural"),
    value: TIPO_DOCUMENTO_ENUM.PEDIDO,
  },
  [TIPO_DOCUMENTO_ENUM.PRESUPUESTO]: {
    text: t("documentos.validar.select.quotationLabel"),
    pluralText: t("documentos.validar.select.quotationLabelPlural"),
    value: TIPO_DOCUMENTO_ENUM.PRESUPUESTO,
  },
})

export const FLOW_STATUS_KEYS: Record<number, FlowStatusKey> = {
  1: {
    label: "Pendiente",
    value: 1,
    status: "warning",
  },
  2: {
    label: "Validado",
    value: 2,
    status: "success",
    icon: "circle-check",
    iconColor: "#FFFFFF",
    backgroundColor: "#30D59B",
    smallIcon: "circle-check",
  },
  3: {
    label: "Rechazado",
    value: 3,
    status: "error",
    icon: "xmark",
    iconColor: "#E40139",
    backgroundColor: "#FFFFFF",
    smallIcon: "circle-xmark",
  },
}

export const FLOW_STATUS_OPTIONS = [
  {
    label: FLOW_STATUS_KEYS[2].label,
    value: FLOW_STATUS_KEYS[2].value,
    id: 11,
  },
  {
    label: FLOW_STATUS_KEYS[3].label,
    value: FLOW_STATUS_KEYS[3].value,
    id: 12,
  },
]

export const FLOW_STATUS_SUCCESS = "success"

export const FLOW_STATUS_KEYS_DROPDOWN: Record<number, FlowStatusKey> = {
  1: {
    label: "pending",
    value: 1,
    status: "warning",
  },
  2: {
    label: "approved",
    value: 2,
    status: "success",
    icon: "circle-check",
    iconColor: "#FFFFFF",
    backgroundColor: "#30D59B",
    smallIcon: "circle-check",
  },
  3: {
    label: "rejected",
    value: 3,
    status: "error",
    icon: "xmark",
    iconColor: "#E40139",
    backgroundColor: "#FFFFFF",
    smallIcon: "circle-xmark",
  },
}
export const FLOW_STATUS_OPTIONS_DROPDOWN = (t: i18n["t"]) => {
  const approved = `shared.dropdown.${FLOW_STATUS_KEYS_DROPDOWN[2].label}`
  const rejected = `shared.dropdown.${FLOW_STATUS_KEYS_DROPDOWN[3].label}`
  return [
    {
      label: t(approved),
      value: FLOW_STATUS_KEYS_DROPDOWN[2].value,
      id: 11,
    },
    {
      label: t(rejected),
      value: FLOW_STATUS_KEYS_DROPDOWN[3].value,
      id: 12,
    },
  ]
}

export const DOCUMENT_TYPE_SERVICE: DocumentTypeServiceMap = {
  2: {
    label: "Factura",
    service: FacturaService,
  },
  18: {
    label: "Albarán",
    service: AlbaranService,
  },
  24: { label: "Pedido", service: PedidoService },
  25: {
    label: "Presupuesto",
    service: PresupuestoService,
  },
}

export const TYPE_TAXES = {
  impuestos: "impuestos",
  retencion: "retenciones",
}
